/**
 * Coin bundles — the USD → coin ladder sold in the store.
 *
 * Mirrors apps/nextjs/src/config/coin-bundles.ts. Keep the two in step: the
 * webapp copy is what the server credits against, and `id` is the Jest IAP
 * product SKU, so a tier added here must also be registered in the Jest store.
 *
 * The entry tier exists to sit UNDER the cheapest pack (Rookie, 300c / $3) so
 * the real first spend is the pack price, not a ten-dollar bundle.
 */

export interface CoinBundle {
  id: string;
  coins: number;
  priceUsdCents: number;
  label: string;
  displayPrice: string;
  /** Marketing badge, percent. Omitted on the flat-rate tiers. */
  bonus?: number;
}

export const COIN_BUNDLES: readonly CoinBundle[] = [
  // Flat $0.01/coin — at $4.99 the tier above it becomes strictly dominated.
  { id: "coins_500", coins: 500, priceUsdCents: 500, label: "500 Coins", displayPrice: "$5.00" },
  { id: "coins_1000", coins: 1000, priceUsdCents: 999, label: "1,000 Coins", displayPrice: "$9.99" },
  { id: "coins_2500", coins: 2500, priceUsdCents: 1999, label: "2,500 Coins", displayPrice: "$19.99", bonus: 10 },
  { id: "coins_5500", coins: 5500, priceUsdCents: 3999, label: "5,500 Coins", displayPrice: "$39.99", bonus: 15 },
];
